import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {choose} from 'lit/directives/choose.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../../../store';
import {LocationState} from '../../../slices/lightProfileSlice';

@customElement('visual-solar-location')
export class VisualSolarLocation extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}
		.container {
			width: 100%;
		}
		.defaultLocation {
			width: 100%;
		}

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.location = state.lightProfile.data.project.location;
		this.locationState = state.lightProfile.data.locationState;

	}
	render() {
		const s = this.state;
		return html`
			<div class="container">
				<img class="defaultLocation" src="/line-assets/img/earth.jpg"/>
			</div>
		`;
	}
}
